import { render, staticRenderFns } from "./OidcConfirmations.vue?vue&type=template&id=62224bfa&scoped=true"
import script from "./OidcConfirmations.vue?vue&type=script&lang=ts"
export * from "./OidcConfirmations.vue?vue&type=script&lang=ts"
import style0 from "./OidcConfirmations.vue?vue&type=style&index=0&id=62224bfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62224bfa",
  null
  
)

export default component.exports